// extracted by mini-css-extract-plugin
module.exports = {"modal":"reviewEventModal_modal__3qL15","cardWrapper":"reviewEventModal_cardWrapper__1qQsM","iconStyle":"reviewEventModal_iconStyle__1WG1L"};